<template>
  <div class="choose-area-dialog" style="max-height: 700px;overflow-y: auto;">
    <el-dialog width="480px" title="请选择您需要办理的地市" :before-close="resetChosenArea" :close-on-click-modal="false" top="0" :visible.sync="$store.state.showToggleArea">
      <div class="city-dialog-level" v-if="cities && cities.length > 0">
        <div class="city-dialog-level-name">市：</div>
        <div class="city-dialog-item">
          <div class="item" :class="{'active': city.jcAreaSeq === chosenArea.jcAreaSeq}" v-for="(city, index) in cities" v-bind:key="index" @click="chooseArea(city)" :title="city.areaName">{{city.areaName}}</div>
        </div>
      </div>
      <div class="city-dialog-level no-border-bottom" v-if="districts && districts.length > 0">
        <div class="city-dialog-level-name">区：</div>
        <div class="city-dialog-item">
          <div class="item" :class="{'active': district.jcAreaSeq === chosenArea.jcAreaSeq}" v-for="(district, index) in districts" v-bind:key="index" @click="chooseArea(district)" :title="district.areaName">{{district.areaName}}</div>
        </div>
      </div>
      <span slot="footer">
        <el-button class="city-dialog-submit" type="primary" @click="submitArea" :disabled="!chosenArea.jcAreaSeq">确定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
  import { loadBizTypeCount } from "@/utils/indexUrl";
  import { Loading } from "element-ui"
  export default {
    name: 'chooseAreaDialog',
    data () {
      return {
        chosenArea: {}, // 选中的地区
        areaInfo: {} // 选中的地区信息
      }
    },
    props: [ 'cities' , 'districts'],
    methods: {
      resetChosenArea() {
        this.chosenArea = this.$store.state.chosenAreaInfo
        this.$store.commit('setShowToggleArea', false)
      },
      submitArea () {
        this.$store.commit('setChosenAreaInfo', this.chosenArea);
        this.$store.commit('setShowToggleArea', false)
      },
      chooseArea (area) {
        this.chosenArea = area
      }
    },
    watch: {
      '$store.state.chosenAreaInfo': {
        handler: async function(val) {
          if(val) {
            this.chosenArea = val
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .city-dialog-level{
    border-bottom: 1px solid #efefef;
    overflow: hidden;
    margin-top: 10px;
    .city-dialog-level-name{
      float: left;
      width: 30px;
      font-size:14px;
      font-weight:400;
      color:rgba(62,151,223,1);
      line-height:38px;
      text-align: right;
    }
    .city-dialog-item{
      margin-left: 50px;
      font-size:14px;
      font-weight:400;
      color:#111111;
      line-height:28px;
      cursor: pointer;
      .item{
        display: inline-block;
        width: 85px;
        text-align: center;
        margin: 5px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .item.active{
        color:rgba(62,151,223,1);
        background: #ecf5ff;
      }
      .item.disabled{
        opacity: 0.3;
        cursor: not-allowed;
      }
    }
  }
  .city-dialog-tips{
    font-size:14px;
    font-family:PingFangSC-Regular,PingFangSC;
    font-weight:400;
    color:rgba(114,116,117,1);
    line-height:38px;
    margin-top: 20px;
  }
  .city-dialog-submit.el-button{
    width: 128px;
    height: 38px;
  }
</style>
